import get = require('lodash/get');

export type QuoteOrder = 'standard' | 'side-by-side';

export const standardiseName = (name: string) => {
    if (!name) { return ''; }
    return name
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (m) => m.toUpperCase());
};

export const getQuoteOrder = (productCode: string): QuoteOrder => {
    if (productCode === 'TPL' || productCode === 'CAMC') { return 'side-by-side'; }
    return 'standard';
};

export const parseDdMmYyyy = (dateStr: string): Date | null => {
    if (!dateStr) { return null; }

    const parts = dateStr.split('/');
    if (parts.length !== 3) { return null; }

    const dd = Number(parts[0]);
    const mm = Number(parts[1]);
    const yyyy = Number(parts[2]);

    if (!dd || !mm || !yyyy) { return null; }
    return new Date(yyyy, mm - 1, dd);
};

export const diffDays = (start: Date, end: Date) => {
    return (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
};

export const isUnableToProvideQuote = (q: any) => {
    if (!q) { return true; }

    const errors = get(q, 'errors', []);
    const declines = get(q, 'declines', []);
    const referrals = get(q, 'referrals', []);

    return (errors && errors.length > 0) ||
        (declines && declines.length > 0) ||
        (referrals && referrals.length > 0);
};

export const flattenBenefits = (benefits: any[], channelKey: string) => {
    const out: any[] = [];
    if (!benefits || !benefits.length) { return out; }

    benefits.forEach((benefit) => {
        if (!benefit || benefit.display === false) { return; }

        const subBenefits: any[] = [];

        if (benefit.subBenefits && benefit.subBenefits.length > 0) {
            benefit.subBenefits.forEach((sb) => {
                if (sb && sb.display !== false) {
                    subBenefits.push({
                        name: sb.name,
                        text: sb.text,
                        subkeyOf: benefit.name,
                    });
                }
            });
        }

        out.push({
            name: channelKey === 'camc-b2c' ? benefit.shortName : benefit.name,
            text: benefit.text ? benefit.text : benefit.description,
            hasSubBenefits: subBenefits.length > 0,
            subBenefits,
        });
    });

    return out;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/schemeChoice.helpers.ts